import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";

const initialState = {};

export const jarvisPrimeActionCenterReducers = persistReducer(
  {
    storage,
    key: "jarvisPrimeActionCenter",
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      default:
        return state;
    }
  }
);
